import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

const fetchUnprocessed = async fileType => {
  const headerConfig = setHeaders();
  const { data } = await axios.get(
    `${config.ENDPOINTS["datalake"]}/preprocessed/${fileType}`,
    {
      headers: headerConfig
    }
  );

  return data;
};

export default function useFetchUnprocessed(fileType) {
  return useQuery(["unprocessed", fileType], () => fetchUnprocessed(fileType), {
    onSuccess: data => {
      //console.log({ data });
    }
  });
}
